import { DeleteTwoTone, SwapRightOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Select, Space } from 'antd';
import { DatePicker } from 'antd/lib';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { validateMessages } from '../../helpers/common';
import { TimKiemNhanVienRequest } from '../../models/nhanvien/NhanVien';
import { xuatBaoCaoNhanVien } from '../../services/report';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ChucDanhChuyenMonSelectBox from './ChucDanhChuyenMon';
import ChucVuSelectBox from './ChucVuSelectBox';
import DanhMucLoaiQuyetDinhSelectBox from './DanhMucLoaiQuyetDinhSelectBox';
import DonViSelectTree from './DonViSelectTree';
import HocHamSelectBox from './HocHamSelectBox';
import NhomNhanSuSelectBox from './NhomNhanSuSelectBox';
import TrinhDoLLCTSelectBox from './TrinhDoLLCTSelectBox';
import KetQuaDanhGiaSelectBox from './KetQuaDanhGiaSelectBox';

const OPTIONS = ['Đơn vị/phòng ban',
    'Tên',
    'Mã nhân viên',
    'Email',
    'Chức vụ',
    'Trình độ học vấn',
    'Chuyên ngành đào tạo',
    'Số điện thoại',
    'Nhóm nhân sự',
    //'Ngày sinh',
    'Chức danh chuyên môn',
    'Giới tính',
    'Tình trạng hôn nhân',
    'Trình độ LLCT',
    'Đảng viên',
    'Quân nhân',
    'Ngày vào làm',
    '[QT làm việc] Ngày bắt đầu',
    '[QT làm việc] Ngày kết thúc',
    '[QT làm việc] Loại quyết định',
    '[QT đào tạo] Tên khóa đào tạo',
    '[QT đào tạo] Ngày bắt đầu',
    '[QT đào tạo] Ngày kết thúc',
    '[Chứng chỉ] Tên chứng chỉ',
    '[Chứng chỉ] Áp dụng từ ngày',
    '[Chứng chỉ] Áp dụng đến ngày',
    '[Đánh giá xếp loại] Năm',
    '[Đánh giá xếp loại] Kết quả',
    '[Khen thưởng] Ngày ký',
    '[Khen thưởng] Thành tích',
    '[Kỷ luật] Ngày ký',
    '[Kỷ luật] Nội dung',
];

const TimKiemNangCaoSelectBox = ({ searchInput, onSubmit }: { searchInput?: any , onSubmit?: (e: any) => void }) => {
    const [selectedItems, setSelectedItems] = useState<any[]>(["Đơn vị/phòng ban", "Tên", "Mã nhân viên", "Email", "Chức vụ"]);
    const filteredOptions = OPTIONS.filter((o) => !selectedItems.includes(o));
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const handleChange = (e: any, currentIndex: number) => {
        var temp = [...selectedItems];
        temp[currentIndex] = e;
        setSelectedItems(temp);
    }
    const handleThemTruong = () => {
        setSelectedItems([...selectedItems,null])
    }
    const handleDelete = (index:any) => {
        var temp = [...selectedItems];
        temp.splice(index,1)
        setSelectedItems(temp)
    }
    const onFinish = (values: any) => {
        // Convert tất cả dayjs objects sang ISO string trước khi truyền lên API
        const processed = { ...values };
        Object.keys(processed).forEach(key => {
            const val = processed[key];
            if (val && typeof val === 'object' && typeof val.toISOString === 'function') {
                processed[key] = val.toISOString();
            }
        });
        if (onSubmit) {
            onSubmit({
                target: {
                    value: processed,
                    label: selectedItems
                }
            });
        }
    }

    const renderInput = (item: any) => { 
        switch (item) {
            case "Tên":
                return <Form.Item name="ten">
                    <Input allowClear/>
                </Form.Item>
            case "Mã nhân viên":
                return <Form.Item name="maNhanVien">
                    <Input allowClear />
                </Form.Item>
            case "Số điện thoại":
                return <Form.Item name="soDienThoai">
                    <Input allowClear />
                </Form.Item>
            case "Email":
                return <Form.Item name="email">
                    <Input allowClear />
                </Form.Item>
            case "Chức vụ":
                return <Form.Item name="idChucVu" >
                    <ChucVuSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Trình độ học vấn":
                return <Form.Item name="idHocHam" >
                    <HocHamSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Chuyên ngành đào tạo":
                return <Form.Item name="tenChuyenNganhDaoTao">
                    <Input allowClear placeholder="Nhập chuyên ngành đào tạo..." />
                </Form.Item>
            case "Nhóm nhân sự":
                return <Form.Item name="idNhomNhanSu" >
                    <NhomNhanSuSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Đơn vị/phòng ban":
                 return <Form.Item name="idDonVi" >
                     <DonViSelectTree onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Ngày sinh":
                return <Form.Item name="ngaySinh" >
                    <DatePicker changeOnBlur={true} style={{ width: "100%" }} placeholder="--Chọn ngày sinh--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                </Form.Item>
            case "Chức danh chuyên môn":
                return <Form.Item name="idChucDanh" >
                    <ChucDanhChuyenMonSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Giới tính":
                return <Form.Item name="gioiTinh" >
                    <Select style={{ width: '100%', height: '35px' }} placeholder="--Chọn giới tính--" allowClear >
                        <Select.Option value={0}>Nam</Select.Option>
                        <Select.Option value={1}>Nữ</Select.Option>
                    </Select>
                </Form.Item>
            case "Tình trạng hôn nhân":
                return <Form.Item name="isKetHon" >
                    <Select style={{ width: '100%', height: '35px' }} placeholder="--Chọn tình trạng hôn nhân--" allowClear >
                        <Select.Option value={0}>Chưa kết hôn</Select.Option>
                        <Select.Option value={1}>Đã kết hôn</Select.Option>
                    </Select>
                </Form.Item>
            case "Trình độ LLCT":
                return <Form.Item name="idTrinhDoLLCT" >
                    <TrinhDoLLCTSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "Đảng viên":
                return <Form.Item name="isDangVien" >
                    <Select style={{ width: '100%', height: '35px' }} placeholder="--Chọn tình trạng Đảng--" allowClear >
                        <Select.Option value={1}>Là Đảng viên</Select.Option>
                        <Select.Option value={0}>Không là Đảng viên</Select.Option>
                    </Select>
                </Form.Item>
            case "Quân nhân":
                return <Form.Item name="isQuanNhan" >
                    <Select style={{ width: '100%', height: '35px' }} placeholder="--Chọn tình trạng quân nhân--" allowClear >
                        <Select.Option value={1}>Là quân nhân</Select.Option>
                        <Select.Option value={0}>Không là quân nhân</Select.Option>
                    </Select>
                </Form.Item>
            case "Ngày vào làm":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="ngayVaoLam_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="ngayVaoLam_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[QT làm việc] Ngày bắt đầu":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="ngayBatDauQTLV_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="ngayBatDauQTLV_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[QT làm việc] Ngày kết thúc":
                    return (
                        <Row gutter={[16, 0]}>
                            <Col span={24}>
                                <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                    <Form.Item name="ngayKetThucQTLV_TuNgay" >
                                        <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                    <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                    <Form.Item name="ngayKetThucQTLV_DenNgay" >
                                        <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    );
            case "[QT làm việc] Loại quyết định":
                return <Form.Item name="idLoaiQuyetDinh" >
                    <DanhMucLoaiQuyetDinhSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "[QT đào tạo] Tên khóa đào tạo":
                return <Form.Item name="daoTao_Ten">
                    <Input allowClear />
                </Form.Item>
            case "[QT đào tạo] Ngày bắt đầu":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="daoTao_NgayBatDau_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="daoTao_NgayBatDau_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[QT đào tạo] Ngày kết thúc":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="daoTao_NgayKetThuc_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="daoTao_NgayKetThuc_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[Chứng chỉ] Tên chứng chỉ":
                return <Form.Item name="chungChi_Ten">
                    <Input allowClear />
                </Form.Item>
            case "[Chứng chỉ] Áp dụng từ ngày":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="chungChi_NgayBatDau_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="chungChi_NgayBatDau_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[Chứng chỉ] Áp dụng đến ngày":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="chungChi_NgayKetThuc_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="chungChi_NgayKetThuc_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[Đánh giá xếp loại] Năm":
                return <Form.Item name="danhGia_Nam">
                    <Input allowClear type="number" />
                </Form.Item>
            case "[Đánh giá xếp loại] Kết quả":
                return <Form.Item name="danhGia_KetQua" >
                    <KetQuaDanhGiaSelectBox onChange={(e: any) => { form.setFieldValue({ item }, e.target.value); }} allowClear />
                </Form.Item>
            case "[Khen thưởng] Thành tích":
                return <Form.Item name="khenThuong_ThanhTich">
                    <Input allowClear />
                </Form.Item>
            case "[Khen thưởng] Ngày ký":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="khenThuong_NgayQuyetDinh_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="khenThuong_NgayQuyetDinh_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
            case "[Kỷ luật] Nội dung":
                return <Form.Item name="kyLuat_NoiDung">
                    <Input allowClear />
                </Form.Item>
            case "[Kỷ luật] Ngày ký":
                return (
                    <Row gutter={[16, 0]}>
                        <Col span={24}>
                            <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', gap: '16px', height: '36px' }}>
                                <Form.Item name="kyLuat_NgayQuyetDinh_TuNgay" >
                                    <DatePicker suffixIcon={null} changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Bắt đầu--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                                <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} rev="" />
                                <Form.Item name="kyLuat_NgayQuyetDinh_DenNgay" >
                                    <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Kết thúc--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                </Form.Item>
                            </div>
                        </Col>
                    </Row>
                );
        }
    }

    useEffect(() => {
        if (searchInput) {
            if (searchInput.labels.includes("Ngày sinh") && searchInput.values.ngaySinh != undefined)
            {
                searchInput.values.ngaySinh = dayjs(searchInput.values.ngaySinh, "DD/MM/YYYY")
            }
            if (searchInput.labels.includes("Ngày vào làm") && searchInput.values.ngayVaoLam != undefined ) {
                searchInput.values.ngayVaoLam = dayjs(searchInput.values.ngayVaoLam, "DD/MM/YYYY")
            }
            form.setFieldsValue(searchInput.values);
            setSelectedItems(searchInput.labels)
        }
    }, []);
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            form.validateFields().then(async (values) => { onFinish(values); });
        }
    };

    const xuatBaoCao = async (request: TimKiemNhanVienRequest) => {
        try {
            dispatch(showLoadingScreen());
            var response = await xuatBaoCaoNhanVien(request);
            let link = document.createElement('a');

            link.download = `NhanSu_QuyDauTu.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            dispatch(hideLoadingScreen());
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
            dispatch(hideLoadingScreen());
        }
    }
    return (
        <>
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
                onKeyPress={handleKeyPress}
            >
            {selectedItems.map((item, index) => {
                return <Row className="mb-2" gutter={8} key={index} style={{ width: '100%', height: '40px' }}>
                    <Col span="12">
                        <Select
                            placeholder="--Chọn trường--"
                            value={item}
                            onChange={(e) => handleChange(e, index)}
                            style={{ width: '100%',height:'35px' }}
                            options={filteredOptions.map((item) => ({
                                value: item,
                                label: item,
                            }))}
                            showSearch
                            filterOption={function (search, item: any) {
                                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                            }}
                        />
                    </Col>
                    <Col span="11">
                        {renderInput(item)}
                    </Col>
                    <Col span="1">
                        <Button type="text" icon={<DeleteTwoTone twoToneColor="red" rev="" />} onClick={() => handleDelete(index)} />
                    </Col>
                </Row>
            })}
                <Row className="mb-2" gutter={16}>
                    <Col span="12">
                        {selectedItems.length < OPTIONS.length &&
                            <Button className="float-left" type="link" onClick={handleThemTruong}>
                                Thêm trường
                            </Button>
                        }
                    </Col>
                    <Col span="12">
                        <Space className='float-right'>
                            <Button 
                                onClick={() => {
                                    setSelectedItems(["Đơn vị/phòng ban", "Tên", "Mã nhân viên", "Email", "Chức vụ"])
                                    form.resetFields();
                                }}>
                                Làm mới
                            </Button>
                            <Button className="hrm-btn hrm-btn-success"
                                onClick={() => {
                                    form.validateFields().then(async (values) => {
                                        xuatBaoCao(values);
                                    });
                                }}>
                                Xuất excel
                            </Button>
                            <Button type="primary" htmlType="submit">
                                Tìm kiếm
                            </Button>
                        </Space>
                    </Col>
            </Row>
            </Form>
        </>
    );
};

export default TimKiemNangCaoSelectBox;
